import React, { useState, useEffect } from "react";
import ComboSelector, { TipoClave } from "../UI/campos/ComboSelector.js";
import MensajeError from "../UI/MensajeError.js";
import * as UI from "../constantes/UI.js";
import useGetListaURL from "../../hooks/useGetListaURL.js";

const SelectProvincia = (props) => {
  const pais = props.pais;
  const provinciaActual = props.provinciaActual;
  const incluirNulo = props.incluirNulo || false;
  const estilo = props.estilo;
  const [lista, setLista] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const setListaProvincias = (provincias) => {
      if (incluirNulo) {
        setLista([{ id: null, nombre: UI.ITEM_COMBO_VACIO }, ...provincias]);
      } else {
        setLista(provincias);
      }
    }

    if (pais && pais.id > 0) {
      fetchData("paises/" + pais.id + "/provincias", setListaProvincias);
    } else {
      setLista([]);
    }
  }, [fetchData, pais, incluirNulo]);

  const onItemElegido = (itemElegido) => {
    props.onProvinciaElegida(itemElegido);
  };

  let valorActual = "";
  if (provinciaActual) {
    if (provinciaActual.nombre) {
      valorActual = provinciaActual.nombre;
    } else if (lista.length > 0) {
      for (let i=0; i < lista.length; i++) {
        if (Number(lista[i].id) === Number(provinciaActual.id)) {
          valorActual = lista[i].nombre;
          break;
        }
      }
    }
  }

  return (
    <React.Fragment>
      <ComboSelector
        estilo={estilo}
        lista={lista}
        valorActual={valorActual}
        campoClave={TipoClave.ID}
        campoDescripcion="nombre"
        isCargando={isCargando}
        onItemElegido={onItemElegido}
      />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectProvincia;
